import { UpgradePromotionBoxCopy } from '@chegg-wt/core/types/copy'
import { UpgradeCopy } from '@chegg-wt/core/types/core'
import { ListItemProps } from '@chegg/wt-checkout'
import * as testIds from '@chegg-wt/core/components/UpgradeAdFrame/testIds'
import { TRY_IT_FOR_FREE_CTA } from '@chegg-wt/core/components/UpgradeAdFrame/constants'

export const upgradePromotionCopy: UpgradePromotionBoxCopy = {
  buttonText: 'Try it now',
  mainHeading: 'Check your paper before your teacher does!',
  subHeading:
    'Avoid plagiarism — quickly check for missing citations and check for writing mistakes.',
}

export const flankerDesignUpgradeCopy: UpgradeCopy = {
  button: TRY_IT_FOR_FREE_CTA,
  header: 'All of our writing tools, none of the ads',
  body: [
    {
      bullet: 'No ads',
      dataTestId: testIds.UPGRADE_NO_ADS,
    },
    {
      bullet: 'MLA and APA citation styles + 7,000 more',
      dataTestId: testIds.UPGRADE_BULLET_STYLES,
    },
    {
      bullet: 'Scan your paper for plagiarism mistakes',
      dataTestId: testIds.UPGRADE_BULLET_PLAGIARIAM,
    },
    {
      bullet: 'Check for 400+ advanced grammar errors',
      dataTestId: testIds.UPGRADE_BULLET_GRAMMAR,
    },
    {
      bullet: 'Create in-text citations and save them',
      dataTestId: testIds.UPGRADE_BULLET_INTEXT,
    },
    {
      bullet: 'Free 3-day trial. Cancel anytime.*',
      dataTestId: testIds.UPGRADE_BULLET_TRIAL,
      isFreeTrial: true,
    },
  ],
}

// WT-Checkout FeatureList
export const bmFeatureList: ListItemProps[] = [
  {
    text:
      'Improving sentence structure, punctuation, writing style, and grammar with our suggestions',
  },
  {
    text: 'Check for missing citations and unintentional plagiarism',
  },
  {
    text: 'Add accurate citations and a bibliography directly to your paper',
  },
  {
    text: 'Create accurate citations for multiple styles and source types',
  },
]
